export default {
  state: {
    sqId: '',                // sqId
    sqtim: null                // sqtim实例
  },
  mutations: {
    set_sq_tim (state, val) {
      state.sqtim = val
      console.log('set_sq_tim', val)
    },
    set_TIMMessage (state, val) {
      state.TIMMessage = val
    },
    set_sqId (state, val) {
      state.sqId = val
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/superQuiz.js